module.exports = __webpack_public_path__ + "img/icon-arrow-rigth-blue.c5ccd0aa.svg";